<template>
  <v-tooltip bottom :color="isTransparent">
    <template v-slot:activator="{ on, attrs }">
      <AxiomAnnotation v-if="axiomAnnotations.length" :axiomAnnotations="axiomAnnotations"
        :aProposDe="parentNode + ' - ' + title" />
      <span class="font-weight-bold" v-bind="attrs" v-on="on" v-text="labelTodisplay">
      </span>
    </template>

    <span v-if="title !== label">{{ titleToDisplay }}</span>

  </v-tooltip>
</template>

<script>
import StoreConfiguration from "../../store-configuration";

export default {
  name: "TooltipLabel",

  data() {
    return {
      lang: this.$route.query.lang,
      storeConfiguration: StoreConfiguration.state,
    }
  },

  watch: {
    $route(to, from) {
      if (this.$route.query.lang !== undefined && to.query.lang !== from.query.lang) {
        this.onLangueChanged(this.$route.query.lang.toUpperCase());
      }
    },
  },
  props: {
    parentKey: {
      type: String,
      default: '',
    },
    negative: {
      type: Boolean,
      default: false,
    },
    title: String,
    label: String,
    parentNode: {
      type: String,
      default: ''
    },
    axiomAnnotations: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    labelTodisplay() {
      return this.getDisplayText(this.label);
    },

    titleToDisplay() {
      return this.getDisplayText(this.title);
    },

    isTransparent: function () {
      return this.label && this.title === this.label ? 'transparent' : '';
    }
  },
  methods: {
    onLangueChanged(lang) {
      this.lang = lang;
      this.$forceUpdate();
    },

    getDisplayText(text) {
      if (!this.negative) return text;

      const prefix = (this.lang === 'EN' || this.lang === 'en') ? 'NOT' : 'NON';
      return `${prefix} (${text})`;
    }
  },
};
</script>